import React from 'react'
import { createContext, useContext, useState, useEffect, useCallback } from "react";

const WebCfg = createContext();

function GetJson(url){
  //console.log(url)
  var ret = null
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.withCredentials = true;
  xmlhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {
      //console.log(this.responseText)
      ret = JSON.parse(this.responseText);
    }
  };
  xmlhttp.open("GET", url, false);
  xmlhttp.send();
  return ret;
}


const GetWebCfg = ()=>{
  try{
    var webCfg = GetJson( "/api/WebCfg?_=" + new Date().getTime());
    console.log(webCfg);
    return webCfg;
  }catch(err){
    console.log(err)
  }
  return null;
}

const refreshSec = 60*30;
var countdown = refreshSec;

export const WebCfgProvider = ({children})=>{
  const[webCfg,setWebCfg] = useState(GetWebCfg())

  const refresh = useCallback( async () => {
    var newVal = GetWebCfg();
    if(newVal)
      setWebCfg(newVal);
  },[])

  useEffect(() => {
    const interval = setInterval(() => {
      countdown--;
      if(countdown <=0){
        countdown = refreshSec;
        refresh();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [refresh]);

  return (
    < WebCfg.Provider value={webCfg?{...webCfg, refresh}:false}>
        {webCfg?children:null}
    </ WebCfg.Provider>
  )
};

export const useWebCfg = () => {
  return useContext( WebCfg);
};